const MXNbilhubOptions = [
    {value: "MEMBER A", label: "Member A"},
    {value: "BANXICO", label: "Banco de México"},
    {value: "BANCOMEXT", label: "Banco Nacional de Comercio Exterior S.N.C."},
    {value: "BANOBRAS", label: "Banco Nacional de Obras y Servicios Públicos, S.N.C."},
    {value: "BANJERCITO", label: "Banco Nacional del Ejército, Fuerza Aérea y Armada SNC"},
    {value: "NAFIN", label: "Nacional Financiera, S.N.C."},
    {value: "BANSEFI", label: "Banco del Ahorro Nacional y Servicios Financieros"},
    {value: "HIPOTECARIA FED", label: "Sociedad Hipotecaria Federal, S.N.C.,"},
    {value: "BANAMEX", label: "Banco Nacional de México, S.A."},
    {value: "BBVA BANCOMER", label: "BBVA México S.A."},
    {value: "SANTANDER", label: "Banco Santander México"},
    {value: "HSBC", label: "HSBC Holdings plc"},
    {value: "BAJIO", label: "Banco del Bajío, S.A."},
    {value: "INBURSA", label: "El Grupo Financiero Inbursa"},
    {value: "MIFEL", label: "Banca Mifel S.A."},
    {value: "SCOTIABANK", label: "El Banco de Nueva Escocia"},
    {value: "BANREGIO", label: "Banregio Grupo Financiero. S.A.B. de C.V/Banco Regional S.A."},
    {value: "INVEX", label: "BANCO INVEX, S.A."},
    {value: "BANSI", label: "BANSí, S.A."},
    {value: "AFIRME", label: "Banca Afirme, S.A."},
    {value: "BANORTE", label: "Banco Mercantil del Norte"},
    {value: "ACCENDO BANCO", label: "ACCENDO BANCO S.A."},
    {value: "AMERICAN EXPRES", label: "American Express Company (México), S.A. de C.V."},
    {value: "BANK OF AMERICA", label: "Banco de América «de Estados Unidos»"},
    {value: "MUFG", label: "MUFG Bank México S.A."},
    {value: "JP MORGAN", label: "JP Morgan Chase"},
    {value: "BMONEX", label: "Monex Grupo Financiero, S.A. de C.V."},
    {value: "VE POR MAS", label: "Banco Ve por Más S.A."},
    {value: "DEUTSCHE", label: "Deutsche Bank Mexico, S.A."},
    {value: "CREDIT SUISSE", label: "Banco Credit Suisse (México), S.A."},
    {value: "AZTECA", label: "Banco Azteca, S. A."},
    {value: "AUTOFIN", label: "Banco Autofin México, S.A."},
    {value: "BARCLAYS", label: "Barclays Bank México, S.A."},
    {value: "COMPARTAMOS", label: "Banco Compartamos S.A."},
    {value: "MULTIVA BANCO", label: "Banco Multiva, S. A."},
    {value: "ACTINVER", label: "Banco Actinver, S. A"},
    {value: "INTERCAM BANCO", label: "Intercam Banco, S.A."},
    {value: "BANCOPPEL", label: "BanCoppel S.A"},
    {value: "ABC CAPITAL", label: "Abc Capital S.A. de C.V."},
    {value: "CONSUBANCO", label: "Consubanco S.A."},
    {value: "VOLKSWAGEN", label: "Volkswagen Bank S.A."},
    {value: "CIBANCO", label: "CIBanco S.A."},
    {value: "BBASE", label: "Banco BASE, S.A."},
    {value: "BANKAOOL", label: "Bankaool S.A"},
    {value: "PAGATODO", label: "Banco PagaTodo, S.A."},
    {value: "INMOBILIARIO", label: "Banco Inmobiliario S.A."},
    {value: "DONDE", label: "Fundación Dondé Banco, S.A."},
    {value: "BANCREA", label: "Banco Bancrea, S.A."},
    {value: "PROGRESO", label: "Banco Dominicano del Progreso, S.A."},
    {value: "BANCO FINTERRA", label: "Banco Finterra, s.a."},
    {value: "ICBC", label: "Industrial and Commercial Bank of China Limited"},
    {value: "SABADELL", label: "Banco de Sabadell, S.A."},
    {value: "SHINHAN", label: "Banco Shinhan de México, S.A."},
    {value: "MIZUHO BANK", label: "Mizuho Bank México S.A."},
    {value: "BANK OF CHINA", label: "Bank of China México, S.A."},
    {value: "BANCO S3", label: "Banco S3 CACEIS México, S. A."},
    {value: "Banxico Pruebas", label: "Banxico Pruebas"},
    {value: "BANCO PRUEBAS", label: "BANCO PRUEBAS"},
    {value: "Banco Fácil R", label: "Banco Fácil, S.A"},
    {value: "Banco Fácil", label: "Banco Fácil, S.A"},
    {value: "BanCobroB", label: "BanCobroB"},
    {value: "BanCobroA", label: "BanCobroA"},
    {value: "Banco Fácil2", label: "Banco Fácil2"},
    {value: "MONEXCB", label: "Banco Monex, S.A.,"},
    {value: "GBM", label: "Grupo Bursátil Mexicano, S.A.B. de C.V."},
    {value: "MASARI", label: "Masari Casa de Bolsa, S.A."},
    {value: "VALUE", label: "VALUE GRUPO FINANCIERO S.A.B. DE C.V."},
    {value: "ESTRUCTURADORES", label: "ESTRUCTURADORES"},
    {value: "VECTOR", label: "Vector Casa de Bolsa, S.A. de C.V."},
    {value: "MULTIVA CBOLSA", label: "Banco Multiva, S. A"},
    {value: "FINAMEX", label: "Casa de Bolsa Finamex, S.A. Bursátil de C.V."},
    {value: "VALMEX", label: "Operadora Valmex de Sociedades de Inversión, S.A. de C.V."},
    {value: "PROFUTURO", label: "GRUPO PROFUTURO,S.A. DE C.V."},
    {value: "CB INTERCAM", label: "Intercam Banco, S.A."},
    {value: "CI BOLSA", label: "CICasa de Bolsa S.A. de C.V."},
    {value: "FINCOMUN", label: "Servicios Financieros Comunitarios, S.A. de C.V., S.F.P."},
    {value: "HDI SEGUROS", label: "HDI Seguros, S.A. de C.V."},
    {value: "AKALA", label: "Akala, S.A. de C.V."},
    {value: "REFORMA", label: "Operadora de Recursos Reforma, S.A. de C.V., S.F.P."},
    {value: "STP", label: "Sistema de Transacciones y Pagos"},
    {value: "EVERCORE", label: "Evercore Casa de Bolsa SA de CV"},
    {value: "CREDICAPITAL", label: "CrediCapital"},
    {value: "KUSPIT", label: "Kuspit Casa de Bolsa S.A. de C.V."},
    {value: "UNAGRA", label: "UNAGRA, S. A. de C. V."},
    {value: "ASP INTEGRA OPC", label: "ASP Integra Opciones"},
    {value: "LIBERTAD", label: "Libertad Servicios Financieros SA de CV"},
    {value: "C.B. INBURSA", label: "Banco Inbursa, S.A."},
    {value: "CAJA POP MEXICA", label: "Caja Popular Mexicana S.C. de A.P. de R.L. de C.V."},
    {value: "CRISTOBAL COLON", label: "Caja Popular Cristóbal Colón."},
    {value: "CAJA TELEFONIST", label: "Caja de Ahorro de los Telefonistas, S.C de A.P. de R.L. de C.V."},
    {value: "TRANSFER", label: "Banco Nacional de México SA"},
    {value: "FONDO (FIRA)", label: "Fondo Especial para Financiamientos Agropecuarios"},
    {value: "INVERCAP", label: "Afore InverCap S.A. de C.V."},
    {value: "CREDICLUB", label: "Crediclub, S.A. de C.V."},
    {value: "FOMPED", label: "Fondo Mexicano del Petróleo para la Estabilización y el Desarrollo"},
    {value: "XXIBANORTE", label: "Grupo Financiero Banorte, S.A.B. de C.V."},
    {value: "OPORMEX", label: "Porcicultores Mexicanos"},
    {value: "TE CREEMOS", label: "Te Creemos Sfp S.A. de C.V."},
    {value: "SC PROM Y OP", label: "SC PROM Y OP"},
    {value: "CAPITAL ACTIVO", label: "Banco Capital S.A.,"},
    {value: "BURSAMETRICA", label: "BURSAMETRICA CASA DE BOLSA, S.A. de C.V."},
    {value: "NVIO", label: "NVIO"},
    {value: "INDEVAL", label: "S.D. Indeval"},
    {value: "CoDi Valida", label: "CoDi Valida"},
    {value: "BanCobro R", label: "BanCobro R"},
    {value: "BanCobro", label: "Bancobro S.c."},
    {value: "BanCobro2", label: "BanCobro2"},
    {value: "Validador", label: "Validador"},
    {value: "BANAMEX2", label: "Banco Nacional de México, S.A."},
    {value: "BBVA BANCOMER2", label: "BBVA México S.A."},
    {value: "SANTANDER2", label: "Banco Santander México"},
    {value: "HSBC2", label: "HSBC Holdings plc"},
    {value: "BANORTE2", label: "Banco Mercantil del Norte"},
    {value: "AZTECA2", label: "Banco Azteca, S. A."},
    {value: "ARCUS", label: "Arcus"},
    {value: "ALTERNATIVOS", label: "ALTERNATIVOS"},
];

export default MXNbilhubOptions;
